var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('header-test',{attrs:{"theme":_vm.isDark}}),(_vm.isComponent('pr-dash'))?_c('data-view'):_c('no-device',{attrs:{"message":_vm.subscriptionMessage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }